import { ToggleButton, ToggleButtonGroup, type Key } from "react-aria-components";
import styles from "./Segmented.module.css";

/** Umschalter für wenige gleichrangige Ansichten (z. B. Kontenfilter). */
export function Segmented({
  label,
  items,
  value,
  onChange,
}: {
  label: string;
  items: Array<{ id: string; label: string }>;
  value: string;
  onChange: (id: string) => void;
}) {
  return (
    <ToggleButtonGroup
      aria-label={label}
      selectionMode="single"
      disallowEmptySelection
      selectedKeys={[value]}
      onSelectionChange={(keys: Set<Key>) => {
        const k = [...keys][0];
        if (k !== undefined) onChange(String(k));
      }}
      className={styles.group}
    >
      {items.map((i) => (
        <ToggleButton key={i.id} id={i.id} className={styles.item}>
          {i.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
